/**
 * Distillery filters component
 */

import { Select, SearchBar } from '../common';
import { COUNTRIES } from '../../utils/constants';
import './DistilleryFilters.css';

/**
 * Filter controls for distillery list
 * @param {Object} props - Component props
 * @param {Object} props.filters - Current filter values
 * @param {Function} props.onFilterChange - Filter change handler
 * @returns {React.ReactElement} Filters element
 */
export default function DistilleryFilters({ filters, onFilterChange, showAdvanced = true }) {
  const handleSearchChange = (value) => {
    onFilterChange({ ...filters, search: value });
  };

  const handleCountryChange = (e) => {
    onFilterChange({ ...filters, country: e.target.value });
  };

  return (
    <div className="distillery-filters">
      <SearchBar
        value={filters.search || ''}
        onChange={handleSearchChange}
        placeholder="Search distilleries..."
      />

      {showAdvanced && (
        <Select
          label="Country"
          options={[{ value: '', label: 'All Countries' }, ...COUNTRIES.map(c => ({ value: c, label: c }))]}
          value={filters.country || ''}
          onChange={handleCountryChange}
          className="distillery-filters__select"
        />
      )}
    </div>
  );
}
